import { render, staticRenderFns } from "./NewspaperVariant.vue?vue&type=template&id=9ffc93fa"
import script from "./NewspaperVariant.vue?vue&type=script&lang=js"
export * from "./NewspaperVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports